export const pt = {
  language: {
    label: "Idioma",
    pt: "Português",
    en: "English",
    es: "Español",
  },
  theme: {
    label: "Tema",
    light: "Claro",
    dark: "Escuro",
  },
  nav: {
    home: "Início",
    tickets: "Chamados",
    newTicket: "Novo Chamado",
    service: "Atendimento",
    sla: "SLA",
    faq: "FAQ",
    policy: "Política",
    catalog: "Catálogo",
    docs: "Documentação",
    admin: "Admin",
    reports: "Relatórios",
    queues: "Filas",
    changes: "Mudanças",
    approvals: "Aprovações",
    problems: "Problemas",
    menu: "Menu",
    menuTitle: "Navegação",
    groupService: "Atendimento",
    groupManagement: "Gestão",
    groupKnowledge: "Conhecimento",
  },
  common: {
    login: "Login",
    logout: "Sair",
    logoutSuccess: "Logout realizado",
    logoutDescription: "Você foi desconectado com sucesso.",
  },
  roles: {
    admin: "Admin Interno",
    internal: "Administrador",
    analyst: "Analista",
    external: "Usuário",
  },
  user: {
    myTickets: "Meus Chamados",
    servicePanel: "Painel de Atendimento",
    adminDashboard: "Dashboard Admin",
    serviceCatalog: "Catálogo de Serviços",
    editProfile: "Editar perfil",
  },
  profile: {
    title: "Editar perfil",
    name: "Nome",
    email: "E-mail",
    emailReadOnly: "O e-mail não pode ser alterado.",
    avatar: "Foto de perfil",
    avatarChange: "Alterar foto",
    avatarUpload: "Enviar foto",
    avatarCrop: "Recortar foto",
    avatarCropHint: "Ajuste a área da foto. Arraste para reposicionar e use o zoom.",
    avatarCropConfirm: "Usar esta foto",
    avatarCropCancel: "Cancelar",
    changePassword: "Alterar senha",
    sendCode: "Enviar código por e-mail",
    codeSent: "Código enviado. Verifique seu e-mail (válido por 15 min).",
    code: "Código",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar nova senha",
    save: "Salvar",
    saveName: "Salvar nome",
    changePasswordSubmit: "Alterar senha",
    successName: "Nome atualizado.",
    successAvatar: "Foto atualizada.",
    successPassword: "Senha alterada com sucesso.",
    errorCode: "Código inválido ou expirado.",
    errorPasswordMatch: "As senhas não coincidem.",
    errorPasswordLength: "Senha deve ter pelo menos 6 caracteres.",
  },
  notifications: {
    title: "Notificações",
    markAllAsRead: "Marcar todas como lidas",
    none: "Nenhuma notificação",
    markAllAsReadToast: "Notificações marcadas como lidas",
    markAllAsReadDesc: "Todas as notificações foram marcadas como lidas.",
  },
  trial: {
    evaluation: "Período de avaliação",
    ended: "Avaliação encerrada",
    daysLeft: (n: number) =>
      `Você possui ${n} dia${n === 1 ? "" : "s"} de teste com tickets ilimitados.`,
    contact:
      "Seu período de avaliação terminou. Entre em contato para ativar a cobrança e continuar usando o sistema.",
    label: (n: number) =>
      `(Avaliação ${n} dia${n === 1 ? "" : "s"} restante${n === 1 ? "" : "s"})`,
    labelEnded: "(Avaliação encerrada)",
  },
  pageTitle: {
    default: "TEC-IT ITSM - Sistema de Gestão de Chamados",
  },
  businessHours: {
    badgeHuman: "Atendimento Humano",
    badgeOff: "Fora do Horário",
    messageUntil: (time: string) => `Atendimento humano disponível até ${time}`,
    messageBot: (time: string) => `Atendimento por bot. Atendimento humano retorna às ${time}`,
  },
  dashboard: {
    loading: "Carregando chamados...",
    title: "Painel de Atendimento",
    subtitle: "Gestão completa de chamados - Visão Interna",
    refresh: "Atualizar",
    total: "Total",
    open: "Abertos",
    inProgress: "Em Atendimento",
    resolved: "Resolvidos",
    slaExpired: "SLA Vencido",
    unassigned: "Sem Atribuição",
    critical: "Crítica",
    queueN1: "Fila N1 - Primeiro Nível",
    queueN2: "Fila N2 - Segundo Nível",
    queueN3: "Fila N3 - Especializado",
    activeTickets: "Chamados ativos",
    byCategory: "Chamados por Categoria",
    byTechnician: "Chamados por Técnico",
    noData: "Nenhum dado disponível",
    qualityMetrics: "Métricas de Qualidade",
    npsAverage: "NPS Médio",
    reopenRate: "Taxa de Reabertura",
    reopenedCount: (n: number) => `${n} chamados reabertos`,
    transfersEscalations: "Transferências e Escalações",
    totalTransfers: "Total de Transferências",
    ticketsTransferred: "Chamados Transferidos",
    multipleTransfers: (n: number) => `${n} com múltiplas transf.`,
    avgPerTicket: "Média por Chamado",
    filtersTitle: "Filtros e Busca Avançada",
    searchPlaceholder: "Buscar...",
    status: "Status",
    statusActive: "Em andamento",
    statusAll: "Todos os Status",
    statusOpen: "Aberto",
    statusInProgress: "Em Atendimento",
    statusWaiting: "Aguardando Resposta",
    statusResolved: "Resolvido",
    statusClosed: "Fechado",
    priority: "Prioridade",
    priorityAll: "Todas as Prioridades",
    priorityCritical: "Crítica",
    priorityHigh: "Alta",
    priorityMedium: "Média",
    priorityLow: "Baixa",
    type: "Tipo",
    typeAll: "Todos os Tipos",
    typeIncident: "Incidente",
    typeRequest: "Requisição",
    typeProblem: "Problema",
    typeChange: "Mudança",
    queue: "Fila",
    queueAll: "Todas as Filas",
    queueN1Short: "N1 - Primeiro Nível",
    queueN2Short: "N2 - Segundo Nível",
    queueN3Short: "N3 - Especializado",
    company: "Empresa",
    companyAll: "Todas as Empresas",
    assignee: "Responsável",
    assigneeAll: "Todos",
    assigneeUnassigned: "Sem Atribuição",
    sla: "SLA",
    slaAll: "Todos",
    slaExpiredFilter: "SLA Vencido",
    slaWarning: "SLA Próximo",
    clearFilters: "Limpar Filtros",
    ticketsList: "Chamados",
    ticketsListDesc: "Lista completa de chamados com informações detalhadas",
    noCompany: "Sem empresa",
    noRequester: "Sem solicitante",
    category: "Categoria",
    created: "Criado",
    assigneeLabel: "Responsável",
    notAssigned: "Não atribuído",
    noTicketsFound: "Nenhum chamado encontrado",
    adjustFilters: "Ajuste os filtros para encontrar chamados",
    linkedReported: (n: number) => (n === 1 ? "1 pessoa relatou o mesmo" : `${n} pessoas relataram o mesmo`),
  },
  index: {
    serviceCenter: "Central de Serviços",
    heroSubtitle: "Sistema completo de gerenciamento de chamados técnicos e operacionais.",
    heroSubtitle2: "Abra, acompanhe e resolva seus tickets com agilidade e transparência.",
    accessSystem: "Acessar Sistema",
    openTicket: "Abrir Chamado",
    ticketSystem: "Sistema de Chamados",
    ticketSystemDesc: "Sistema automatizado de categorização e priorização baseado em ITIL",
    support24: "Suporte 24/7",
    support24Desc: "Comunicação em tempo real com nossa equipe técnica especializada",
    slaTransparent: "SLA Transparente",
    slaTransparentDesc: "Acompanhe o progresso com indicadores visuais de tempo de resolução",
    totalSecurity: "Segurança Total",
    totalSecurityDesc: "Ambiente seguro com controle de acesso e histórico completo",
    mainResources: "Recursos Principais",
    mainResourcesDesc: "Tudo que você precisa para gerenciar seus chamados de forma eficiente",
    fullManagement: "Gestão Completa",
    fullManagementDesc: "Incidentes, Requisições, Problemas e Mudanças em uma única plataforma integrada",
    intuitiveDashboard: "Dashboard Intuitivo",
    intuitiveDashboardDesc: "Visualize KPIs, métricas de performance e status em tempo real com gráficos interativos",
    mobileFirst: "Mobile First",
    mobileFirstDesc: "Interface responsiva otimizada para todos os dispositivos, acesse de qualquer lugar",
  },
  auth: {
    backToHome: "Voltar ao início",
    backToLogin: "Voltar ao login",
    accessAccount: "Acesse sua conta",
    loginTitle: "Login",
    loginDesc: "Entre com suas credenciais para acessar o sistema de chamados",
    email: "E-mail",
    emailPlaceholder: "seu@email.com",
    password: "Senha",
    forgotPassword: "Esqueci minha senha",
    forgotPasswordAlt: "Esqueceu a senha?",
    rememberMe: "Lembrar-me",
    centralDeServicos: "Central de Serviços",
    accessSystem: "Acessar Sistema",
    openTicket: "Abrir Chamado",
    registerCta: "Registre-se",
    hasAccount: "Já tem conta?",
    signInLink: "Faça login",
    tagline: "Sistema completo de gerenciamento de chamados técnicos e operacionais",
    signIn: "Entrar",
    signingIn: "Entrando...",
    noAccount: "Não tem conta?",
    createAccount: "Criar conta",
    welcomeTitle: "Bem-vindo!",
    welcomeDesc: "Cadastre sua empresa e comece a usar o sistema de chamados.",
    signUpCta: "Criar conta",
    detectingCompany: "Detectando empresa...",
    forcePasswordReset: "Troca de senha obrigatória",
    setNewPassword: "Defina uma nova senha para continuar.",
    loginSuccess: "Login realizado com sucesso!",
    redirecting: "Redirecionando para o dashboard...",
    loginError: "Erro no login",
    invalidCredentials: "Credenciais inválidas",
    connectionError: "Não foi possível conectar ao servidor",
    checkEmail: "Verifique seu e-mail",
    checkEmailDesc: "Se o e-mail existir, você receberá o link.",
    recoveryError: "Erro ao solicitar recuperação",
    recoveryErrorDesc: "Não foi possível processar sua solicitação.",
    recoverPassword: "Recuperar senha",
    forgotTitle: "Esqueci minha senha",
    forgotDesc: "Informe seu e-mail para receber o link de redefinição",
    sendLink: "Enviar link",
    sending: "Enviando...",
    resetPasswordTitle: "Redefinir senha",
    newPassword: "Nova senha",
    newPasswordDesc: "Defina sua nova senha para acessar o sistema",
    invalidLink: "Link inválido ou incompleto. Solicite um novo email de recuperação.",
    confirmPassword: "Confirmar senha",
    savePassword: "Redefinir senha",
    saving: "Salvando...",
    passwordReset: "Senha redefinida",
    passwordResetDesc: "Você já pode fazer login.",
    resetError: "Erro ao redefinir senha",
    resetErrorDesc: "Não foi possível concluir a operação.",
    invalidPassword: "Senha inválida",
    passwordMinLength: "A senha deve ter pelo menos 6 caracteres.",
    passwordsDontMatch: "Senhas não coincidem",
    confirmPasswordCorrect: "Confirme a senha corretamente.",
  },
  register: {
    title: "Cadastro",
    desc: "Preencha os dados para criar sua conta",
    name: "Nome completo",
    namePlaceholder: "Seu nome completo",
    phone: "Telefone",
    phonePlaceholder: "(11) 98765-4321",
    companyDomain: "Domínio da empresa",
    companyDomainPlaceholder: "exemplo.com.br",
    companyDomainHint: "Digite o domínio da sua empresa (sem www)",
    sector: "Setor",
    sectorPlaceholder: "Ex: TI, RH, Financeiro",
    function: "Função",
    functionPlaceholder: "Ex: Analista, Gerente, Coordenador",
    confirmPassword: "Confirmar senha",
    emailHint: "Use o e-mail corporativo da sua empresa",
    passwordHint: "Mínimo de 6 caracteres",
    creatingAccount: "Criando conta...",
    createButton: "Criar conta",
    error: "Erro",
    nameRequired: "Nome é obrigatório.",
    emailRequired: "E-mail é obrigatório.",
    invalidEmail: "E-mail inválido.",
    phoneRequired: "Telefone é obrigatório.",
    domainRequired: "Domínio da empresa é obrigatório.",
    sectorRequired: "Setor é obrigatório.",
    functionRequired: "Função é obrigatória.",
    passwordMin: "Senha deve ter no mínimo 6 caracteres.",
    passwordsDontMatch: "As senhas não coincidem.",
    registerSuccess: "Conta criada com sucesso!",
    registerSuccessDesc: "Redirecionando para o login...",
    registerSuccessMessage: "Você tem 20 dias de avaliação com tickets ilimitados. Após o período, a cobrança será necessária.",
    registerError: "Erro ao cadastrar",
  },
  landing: {
    loginSuccess: "Login realizado com sucesso!",
    redirecting: "Redirecionando para o dashboard...",
    loginError: "Erro no login",
    invalidCredentials: "Credenciais inválidas",
    connectionError: "Não foi possível conectar ao servidor",
    signIn: "Entrar",
    signingIn: "Entrando...",
    accessAccount: "Acesse sua conta",
    noAccount: "Não tem conta?",
    createAccount: "Criar conta",
    forgotPassword: "Esqueci minha senha",
    newAccount: "Criar conta",
  },
  itsmDashboard: {
    title: "Dashboard ITSM",
    subtitle: "Gerencie e acompanhe seus chamados",
    newTicket: "Novo Chamado",
    loading: "Carregando chamados...",
    error: "Erro ao carregar chamados",
    connectionError: "Erro de conexão",
    totalTickets: "Total de Chamados",
    tryAgain: "Tentar novamente",
    searchPlaceholder: "Buscar por ID ou título...",
    filtersTitle: "Filtros e Busca",
    noTickets: "Nenhum chamado encontrado",
    noTicketsDesc: "Você ainda não possui chamados ou os filtros não retornaram resultados.",
    openTicket: "Abrir Chamado",
  },
  footer: {
    companyDesc: "Sistema profissional de gerenciamento de chamados baseado nas melhores práticas ITIL.",
    quickAccess: "Acesso Rápido",
    myTickets: "Meus Chamados",
    openTicket: "Abrir Chamado",
    slaLevels: "Níveis de SLA",
    support: "Suporte",
    servicePolicy: "Política de Serviço",
    contact: "Contato",
    available24: "24/7 Disponível",
    rightsReserved: "Todos os direitos reservados.",
  },
  notFound: {
    title: "404",
    message: "Página não encontrada",
    backHome: "Voltar ao início",
  },
  faq: {
    title: "Central de Ajuda",
    subtitle: "Encontre respostas rápidas para as dúvidas mais comuns sobre o sistema ITSM",
    searchPlaceholder: "Buscar na FAQ...",
    noResults: "Nenhum resultado encontrado",
    categoryGeneral: "Geral",
    categorySla: "SLA e Prioridades",
    categoryTypes: "Tipos de Chamado",
    categoryComm: "Comunicação",
    categoryTech: "Problemas Técnicos",
  },
  sla: {
    title: "Níveis de SLA",
    subtitle: "Nossos compromissos de tempo de resposta e resolução baseados na classificação ITIL. Os prazos começam a contar a partir da abertura do chamado durante horário comercial (8h às 18h, segunda a sexta).",
    howItWorks: "Como funciona nosso SLA",
    responseTime: "Tempo de Resposta",
    responseTimeDesc: "Tempo máximo para que nossa equipe faça o primeiro contato e inicie o atendimento do seu chamado.",
    resolutionTime: "Tempo de Resolução",
    resolutionTimeDesc: "Tempo máximo para resolução completa do chamado, incluindo testes e confirmação com o usuário.",
    serviceHours: "Horário de Atendimento",
    weekdays: "Segunda a Sexta: 08:00 às 18:00",
    emergencies: "Emergências: 24/7 para chamados críticos",
    slaCalculation: "Cálculo do SLA",
    slaCalculationDesc: "Os prazos são calculados apenas durante o horário comercial, exceto para chamados críticos.",
    response: "Resposta",
    resolution: "Resolução",
    priority: "Prioridade",
    description: "Descrição",
    typeIncident: "Incidente",
    typeRequest: "Requisição",
    typeProblem: "Problema",
    typeChange: "Mudança",
    typeIncidentDesc: "Interrupção não planejada ou redução da qualidade de um serviço",
    typeRequestDesc: "Solicitação de um usuário para informação, conselho, mudança padrão ou acesso",
    typeProblemDesc: "Causa desconhecida de um ou mais incidentes existentes ou potenciais",
    typeChangeDesc: "Adição, modificação ou remoção de qualquer coisa que possa afetar os serviços",
    incidentCriticalDesc: "Sistema principal indisponível",
    incidentHighDesc: "Funcionalidade importante afetada",
    incidentMediumDesc: "Problema que afeta poucos usuários",
    incidentLowDesc: "Problema menor ou cosmético",
    requestCriticalDesc: "Acesso urgente a sistema crítico",
    requestHighDesc: "Nova funcionalidade importante",
    requestMediumDesc: "Solicitação padrão",
    requestLowDesc: "Informações ou melhorias",
    problemCriticalDesc: "Causa de múltiplos incidentes críticos",
    problemHighDesc: "Padrão de incidentes recorrentes",
    problemMediumDesc: "Análise preventiva",
    problemLowDesc: "Melhoria de processo",
    changeCriticalDesc: "Mudança de emergência",
    changeHighDesc: "Mudança importante planejada",
    changeMediumDesc: "Mudança padrão",
    changeLowDesc: "Melhoria não urgente",
    notesTitle: "Notas Importantes",
    criticalNote: "Chamados Críticos: Recebem atendimento 24/7, incluindo finais de semana e feriados.",
    communicationNote: "Comunicação: Você será notificado por e-mail a cada mudança de status do chamado.",
    escalationNote: "Escalação: Chamados que excedem 80% do SLA são automaticamente escalados para supervisão.",
    slaPauseNote: "Pausa de SLA: O cronômetro é pausado quando aguardamos resposta do solicitante.",
    reopenNote: "Reabertura: Chamados podem ser reabertos em até 48h após o fechamento sem impacto no SLA.",
  },
  servicePolicy: {
    title: "Política de Serviço",
    subtitle: "Conheça nossos padrões de atendimento, responsabilidades e compromissos com a qualidade do suporte técnico.",
    qualityCommitment: "Compromisso com a Qualidade",
    introParagraph: "A TEC-IT está comprometida em fornecer suporte técnico de excelência, seguindo as melhores práticas ITIL (Information Technology Infrastructure Library) para garantir eficiência, transparência e satisfação dos nossos usuários.",
    availability: "Disponibilidade",
    satisfaction: "Satisfação",
    forCritical: "Para Críticos",
    scopeTitle: "Escopo do Serviço",
    scopeDesc: "O que está incluído no nosso suporte técnico",
    included: "Serviços Incluídos",
    excluded: "Serviços Não Incluídos",
    includedItem1: "Suporte a infraestrutura de TI",
    includedItem2: "Manutenção de hardware e software",
    includedItem3: "Configuração de sistemas e redes",
    includedItem4: "Gerenciamento de usuários e acessos",
    includedItem5: "Backup e recuperação de dados",
    includedItem6: "Segurança da informação",
    includedItem7: "Consultoria técnica",
    includedItem8: "Monitoramento de sistemas",
    excludedItem1: "Desenvolvimento de software personalizado",
    excludedItem2: "Treinamento básico de usuários",
    excludedItem3: "Suporte a equipamentos pessoais",
    excludedItem4: "Configurações não-corporativas",
    excludedItem5: "Recuperação de dados por negligência",
    excludedItem6: "Manutenção física de equipamentos antigos",
    excludedItem7: "Licenciamento de software terceiros",
    excludedItem8: "Suporte a sistemas não homologados",
    serviceHoursTitle: "Horários de Atendimento",
    businessHours: "Horário Comercial",
    weekdays: "Segunda a Sexta:",
    weekdaysTime: "08:00 às 18:00",
    saturday: "Sábado:",
    saturdayTime: "08:00 às 12:00",
    sundayHolidays: "Domingo e Feriados:",
    sundayHolidaysTime: "Apenas emergências",
    support247Title: "Atendimento 24/7",
    criticalTicketsBadge: "Chamados Críticos",
    criticalTicketsDesc: "Para incidentes que afetam sistemas críticos ou causam interrupção total dos serviços, oferecemos suporte 24 horas por dia, 7 dias por semana, incluindo feriados.",
    responsibilitiesTecit: "Responsabilidades da TEC-IT",
    responsibilitiesUser: "Responsabilidades do Usuário",
    respTecit1: "Responder aos chamados dentro do SLA estabelecido",
    respTecit2: "Manter comunicação clara e transparente",
    respTecit3: "Documentar todas as ações realizadas",
    respTecit4: "Escalar chamados quando necessário",
    respTecit5: "Manter confidencialidade das informações",
    respTecit6: "Fornecer relatórios de performance",
    respUser1: "Fornecer informações completas e precisas",
    respUser2: "Responder às solicitações de teste/validação",
    respUser3: "Aguardar aprovação antes de mudanças",
    respUser4: "Manter backup de dados importantes",
    respUser5: "Comunicar mudanças no ambiente",
    respUser6: "Avaliar o atendimento após resolução",
    escalationTitle: "Processo de Escalação",
    escalationDesc: "Como os chamados são escalados quando necessário",
    escalationAuto: "Escalação Automática",
    escalationAutoDesc: "Quando o SLA atinge 80% do prazo",
    escalationTech: "Escalação Técnica",
    escalationTechDesc: "Para especialistas quando necessário",
    escalationMgmt: "Escalação Gerencial",
    escalationMgmtDesc: "Para supervisão em casos críticos",
    performanceIndicators: "Indicadores de Performance",
    mainKpis: "KPIs Principais",
    slaCompliance: "Cumprimento de SLA",
    firstResolution: "Primeira Resolução",
    userSatisfaction: "Satisfação do Usuário",
    avgResponseTime: "Tempo Médio de Resposta",
    reportsTitle: "Relatórios",
    reportItem1: "Relatório mensal de performance",
    reportItem2: "Dashboard em tempo real",
    reportItem3: "Análise de tendências",
    reportItem4: "Feedback dos usuários",
    reportItem5: "Planos de melhoria contínua",
    contactFeedbackTitle: "Contato e Feedback",
    contactFeedbackDesc: "Sua opinião é fundamental para melhorarmos nossos serviços",
    contactChannels: "Canais de Contato",
    emailLabel: "E-mail:",
    phoneLabel: "Telefone:",
    chatLabel: "Chat:",
    systemLabel: "Sistema:",
    chatAvailable: "Disponível no sistema",
    systemPortal: "Portal de chamados ITSM",
    complaintsSuggestions: "Reclamações e Sugestões",
    complaintsParagraph: "Para reclamações, sugestões ou elogios, entre em contato com nosso gestor de qualidade através do e-mail qualidade@tec-it.com",
    responseTimeNote: "Todas as mensagens são analisadas e respondidas em até 48 horas úteis.",
  },
  documentation: {
    title: "Documentação",
    subtitle: "Cadastro e estrutura de banco de dados.",
    loading: "Carregando...",
    loadError: "Não foi possível carregar a documentação.",
  },
  floatingHelp: {
    help: "Ajuda",
    needHelp: "Precisa de ajuda?",
    title: "Central de Ajuda",
    description: "Encontre respostas rápidas e entre em contato com nosso suporte",
    ariaLabel: "Ajuda e Suporte",
    humanAvailable: "Atendimento Humano Disponível",
    outsideHours: "Fora do Horário de Atendimento",
    quickAccess: "Acesso Rápido",
    contactUs: "Entre em Contato",
    email: "E-mail",
    phone: "Telefone",
    adminPanel: "Painel Administrativo",
    adminPanelDesc: "Gerenciar sistema e usuários",
    adminPanelDescInternal: "Gerenciar empresa e usuários",
    service: "Atendimento",
    serviceDesc: "Gerenciar chamados",
    reports: "Relatórios",
    reportsDesc: "Análises e métricas",
    manageUsers: "Gerenciar Usuários",
    manageUsersDesc: "Administrar usuários do sistema",
    manageUsersDescInternal: "Administrar usuários da empresa",
    faq: "FAQ",
    faqDesc: "Perguntas frequentes",
    howToOpenTicket: "Como abrir um chamado",
    howToOpenTicketDesc: "Guia passo a passo",
    servicePolicy: "Política de Serviço",
    servicePolicyDesc: "Entenda nossos SLAs",
    myTickets: "Meus Chamados",
    myTicketsDesc: "Acompanhe seus tickets",
    systemSupport: "Suporte do Sistema",
    systemSupportDesc: "Abra um chamado direto com a equipe responsável pela plataforma.",
    titleLabel: "Título *",
    titlePlaceholder: "Ex: Erro ao criar chamado...",
    descriptionLabel: "Descrição *",
    descriptionPlaceholder: "Descreva o problema e passos para reproduzir.",
    impactLabel: "Impacto *",
    urgencyLabel: "Urgência *",
    impactCritical: "Crítico",
    impactHigh: "Alto",
    impactMedium: "Médio",
    impactLow: "Baixo",
    sending: "Enviando...",
    sendTicketToSupport: "Enviar Chamado ao Suporte",
    mySystemTickets: "Meus chamados do sistema",
    mySystemTicketsDesc: "Acompanhe os últimos chamados que você abriu para o suporte global.",
    loadingTickets: "Carregando chamados...",
    noTicketsYet: "Nenhum chamado aberto ainda.",
    requiredFields: "Campos obrigatórios",
    requiredFieldsDesc: "Informe o título e a descrição do problema.",
    ticketSent: "Chamado enviado",
    ticketSentDesc: (id: string) => `Chamado ${id} criado com sucesso.`,
    error: "Erro",
    errorSendDesc: "Não foi possível abrir o chamado.",
    chatWithAdmin: "Chat com Administrador",
    createNewTicket: "Criar Novo Chamado",
    goToService: "Ir para Atendimento",
    needMoreHelp: "Precisa de mais ajuda? Nossa equipe está pronta para ajudar você.",
  },
  newTicket: {
    title: "Novo Chamado",
    subtitle: "Preencha as informações abaixo para abrir um novo chamado",
    backToTickets: "Voltar aos chamados",
    restrictedAccess: "Acesso restrito",
    restrictedDesc: "Você precisa estar logado para criar um chamado.",
    preselectedService: "Serviço pré-selecionado",
    preselectedDesc: (name: string) => `O formulário foi pré-preenchido com as informações do serviço "${name}".`,
    requiredFields: "Campos obrigatórios",
    requiredFieldsDesc: "Por favor, preencha: O que você precisa, Resumo, Descrição e Área do problema.",
    requiredImpactUrgency: "Por favor, selecione Impacto e Urgência.",
    emailRequired: "E-mail obrigatório",
    emailRequiredDesc: "Por favor, informe o e-mail da pessoa para quem é o chamado.",
    targetCompany: "Empresa de destino",
    targetCompanyHint: "O chamado será aberto dentro da base desta empresa.",
    selectCompany: "Selecione a empresa",
    loadingCompanies: "Carregando empresas...",
    noCompanies: "Nenhuma empresa disponível",
    companyRequired: "Empresa obrigatória",
    companyRequiredDesc: "Selecione em qual empresa o chamado será aberto.",
    invalidEmail: "E-mail inválido",
    invalidEmailDesc: "Por favor, informe um e-mail válido.",
    outsideHours: "Fora do Horário de Atendimento",
    outsideHoursDesc: (time: string) => `Você está fora do horário de atendimento (8h às 2h). Seu chamado será criado e será atendido assim que o horário de atendimento retornar. O atendimento retorna às ${time}.`,
    ticketInfo: "Informações do Chamado",
    ticketInfoDesc: "Forneça o máximo de detalhes possível para acelerar o atendimento",
    whatYouNeed: "O que você precisa? *",
    select: "Selecione...",
    resolveProblem: "Resolver um problema",
    requestSomething: "Solicitar algo novo",
    reportRecurring: "Relatar um problema recorrente",
    makeChange: "Fazer uma alteração",
    summary: "Resumo do problema *",
    summaryPlaceholder: "Ex: Não consigo abrir o Excel",
    summaryHint: "Uma frase curta descrevendo o problema",
    tellMore: "Conte mais sobre o problema *",
    tellMorePlaceholder: "Descreva o que aconteceu, quando começou e o que você estava fazendo quando o problema apareceu. Se houver alguma mensagem de erro, cole aqui.",
    tellMoreHint: "Quanto mais detalhes, mais rápido conseguiremos te ajudar",
    areaOfProblem: "Área do problema *",
    selectArea: "Selecione a área...",
    areaHint: "Em qual área está o problema? Software, Hardware, Acesso, etc.",
    subcategoryOptional: "Tipo específico (opcional)",
    subcategoryPlaceholder: "Se não souber, deixe em branco",
    impact: "Impacto *",
    urgency: "Urgência *",
    selectImpact: "Selecione o impacto...",
    selectUrgency: "Selecione a urgência...",
    critical: "Crítico",
    high: "Alto",
    medium: "Médio",
    low: "Baixo",
    additionalInfo: "Informações Adicionais",
    additionalInfoHint: "Preencha o que souber. Se não souber, pode deixar em branco.",
    optional: "(opcional)",
    forWho: "Este chamado é para *",
    forMyself: "Para mim mesmo",
    forOther: "Para outra pessoa",
    contactEmail: "E-mail para Contato *",
    yourEmailUsed: "(seu e-mail será usado)",
    updatesWillBeSent: "As atualizações do chamado serão enviadas para:",
    contactPhone: "Telefone para Contato (opcional)",
    attachments: "Anexos",
    clickToUpload: "Clique para enviar ou arraste arquivos",
    attachmentsHint: "PNG, JPG, PDF (MAX. 10MB) • Cole prints com Ctrl+V",
    attachedFiles: "Arquivos anexados:",
    remove: "Remover",
    calculatedPriority: "Prioridade Calculada",
    basedOnImpact: (impact: string, urgency: string) => `Baseada no impacto (${impact}) e urgência (${urgency})`,
    estimatedSLA: "SLA Estimado",
    firstResponseTime: "Tempo para primeira resposta",
    tipsTitle: "Dicas para um Chamado Eficiente",
    tip1: "Seja específico no título e descrição",
    tip2: "Inclua prints ou arquivos relevantes",
    tip3: "Informe quando o problema começou",
    tip4: "Descreva as mensagens de erro",
    createTicket: "Abrir Chamado",
    creating: "Criando chamado...",
    loadingCategories: "Carregando categorias...",
    printAdded: "Print adicionado",
    ticketCreated: "Chamado criado com sucesso!",
    ticketCreatedDesc: (id: string) => `Seu chamado ${id} foi criado. Você receberá atualizações por e-mail.`,
    ticketLinked: "Chamado criado e vinculado automaticamente!",
    ticketLinkedDesc: (id: string) => `Seu chamado ${id} foi vinculado a um chamado existente com o mesmo problema. Você receberá atualizações por e-mail.`,
    similarTicketsTitle: "Encontramos chamados com o mesmo problema",
    similarTicketsDesc: "Outras pessoas já relataram isso. É o mesmo problema que você está enfrentando?",
    createNewAnyway: "Não, criar novo chamado",
    useExisting: "Usar chamado existente",
    similarYesSame: "Sim, é o mesmo",
    viewMyTicket: "Ver meu chamado",
    printAddedCount: (n: number) => `${n} imagem(ns) adicionada(s) aos anexos.`,
    reportedBy: "Reportado por:",
    thanksForInfo: "Obrigado pela informação!",
    teamWillCheck: "A equipe vai verificar se seu chamado está relacionado. Se for o mesmo problema, eles vincularão automaticamente.",
    ticketCreatedVerify: "O chamado foi criado. A equipe vai verificar a vinculação.",
    ticketsLinked: "Chamados vinculados!",
    ticketsLinkedDesc: "Seu chamado foi vinculado ao chamado principal. Quando ele for resolvido, o seu também será.",
    errorCreating: "Erro ao criar chamado",
    errorCreatingDesc: "Não foi possível criar o chamado. Tente novamente.",
    limitReached: "Limite de chamados atingido",
    configError: "Erro de configuração",
    configErrorDesc: "A URL da API não está configurada corretamente. Entre em contato com o suporte técnico.",
    connectionError: "Não foi possível conectar ao servidor. Verifique sua conexão com a internet e tente novamente.",
  },
  ticketDetails: {
    loading: "Carregando chamado...",
    notFound: "Chamado não encontrado",
    backToTickets: "Voltar aos chamados",
    createdAt: "Criado em",
    updatedAt: "Atualizado em",
    description: "Descrição",
    communication: "Comunicação",
    communicationDesc: "Histórico de mensagens entre você e a equipe técnica",
    noMessages: "Nenhuma mensagem ainda",
    startConversation: "Inicie a conversa adicionando um comentário abaixo",
    addCommentPlaceholder: "Adicione um comentário ou pergunta...",
    attachImage: "Anexar Imagem (opcional, máx. 10MB)",
    selectImage: "Selecionar Imagem",
    sendComment: "Enviar comentário",
    error: "Erro",
    notFoundDesc: "Chamado não encontrado.",
    loadError: "Não foi possível carregar o chamado.",
    fileTooBig: "Arquivo muito grande",
    fileTooBigDesc: "A imagem deve ter no máximo 10MB.",
    invalidFileType: "Tipo de arquivo inválido",
    invalidFileTypeDesc: "Apenas imagens são permitidas.",
    attention: "Atenção",
    addCommentOrImage: "Por favor, adicione um comentário ou uma imagem.",
    commentAdded: "Comentário adicionado",
    commentAddedDesc: "Sua mensagem foi enviada com sucesso.",
    ratingSent: "Avaliação enviada!",
    ratingSentDesc: "Obrigado pela sua avaliação. Ela nos ajuda a melhorar continuamente.",
    reopenReasonRequired: "Motivo obrigatório",
    reopenReasonDesc: "Por favor, informe o motivo da reabertura. Este motivo será analisado pela equipe.",
    ticketReopened: "Chamado reaberto",
    ticketReopenedDesc: "O chamado foi reaberto com sucesso. O motivo será analisado pela equipe.",
    rateExperience: "Como foi seu atendimento?",
    npsLabel: "Avalie de 0 a 10",
    submitRating: "Enviar avaliação",
    reopenTicket: "Reabrir chamado",
    reopenReason: "Motivo da reabertura",
    submitReopen: "Confirmar reabertura",
    user: "Usuário",
    attachedImage: "Imagem anexada",
    sla: "SLA",
    timeRemaining: "Tempo Restante",
    deadline: "Prazo Final",
    details: "Detalhes",
    type: "Tipo",
    priority: "Prioridade",
    category: "Categoria",
    contactTime: "Contato / Horário",
    assignee: "Responsável",
    notAssigned: "Não atribuído",
    requester: "Solicitante",
    notInformed: "Não informado",
    priorityReportedAtOpen: "Prioridade informada na abertura:",
    rateService: "Avalie o Atendimento",
    ratingSentTitle: "Avaliação Enviada",
    thanksForRating: "Obrigado pela sua avaliação!",
    yourOpinionHelps: "Sua opinião nos ajuda a melhorar continuamente",
    yourNpsRating: "Sua Avaliação NPS",
    scaleZeroToTen: "Escala de 0 a 10",
    yourComment: "Seu Comentário",
    howLikelyRecommend: "Quão provável é você recomendar nosso atendimento? (0-10)",
    promoter: "Promotor",
    neutral: "Neutro",
    detractor: "Detrator",
    promoterDesc: "Você está muito satisfeito!",
    neutralDesc: "Satisfeito, mas pode melhorar",
    detractorDesc: "Não está satisfeito",
    wouldYouComment: "Gostaria de deixar algum comentário? (opcional)",
    commentHint: "Seus comentários são muito importantes para nosso treinamento e controle de qualidade.",
    commentPlaceholder: "Conte-nos mais sobre sua experiência com o atendimento...",
    ratingHelps: "Esta avaliação ajuda-nos a melhorar continuamente nossos serviços",
    reopenSectionTitle: "Reabrir Chamado",
    reopenSectionDesc: "Se o problema não foi resolvido adequadamente, você pode reabrir este chamado",
    reopenReasonLabel: "Motivo da reabertura",
    reopenReasonPlaceholder: "Descreva detalhadamente por que o chamado precisa ser reaberto. Este motivo será analisado pela equipe de atendimento...",
    reopenReasonHint: "O motivo é obrigatório e será analisado pela equipe antes da reabertura",
    reopenDeadlineHint: "O chamado será reaberto e o motivo será analisado pela equipe de atendimento",
    reopening: "Reabrindo...",
    sendingComment: "Enviando...",
  },
  internalTicketDetails: {
    loading: "Carregando chamado...",
    notFound: "Chamado não encontrado",
    backToPanel: "Voltar ao painel de atendimento",
    description: "Descrição",
    companyInfo: "Informações da Empresa",
    company: "Empresa",
    requester: "Solicitante",
    notInformed: "Não informado",
    sla: "SLA",
    slaOverdue: "Vencido",
    timeRemaining: "Tempo Restante",
    deadline: "Prazo Final",
    details: "Detalhes",
    type: "Tipo",
    category: "Categoria",
    impact: "Impacto",
    urgency: "Urgência",
    priority: "Prioridade",
    priorityWithSlaSuffix: " (SLA / Analista)",
    customerPriority: "Solicitante informou prioridade:",
    contact: "Contato do Solicitante",
    assignee: "Responsável",
    notAssigned: "Não atribuído",
    reassign: "Reatribuir",
    assign: "Atribuir",
    relatedTickets: "Chamados Relacionados",
    mainTicket: "Chamado Principal",
    unlink: "Desvincular",
    viewMain: "Ver chamado principal",
    peopleReportedSame: "Pessoas que relataram o mesmo problema",
    peopleReportedCount: (n: number) => (n === 1 ? "1 pessoa relatou este mesmo problema" : `${n} pessoas relataram este mesmo problema`),
    noLinkedTickets: "Este chamado não possui outros chamados vinculados",
    communication: "Comunicação",
    communicationDesc: "Histórico de mensagens e interações",
    noMessages: "Nenhuma mensagem ainda",
    addCommentPlaceholder: "Adicione um comentário...",
    attachImagePaste: "Anexar Imagem (opcional, máx. 10MB) • Cole prints com Ctrl+V",
    selectImage: "Selecionar Imagem",
    attachedImagePreview: "Preview da imagem anexada",
    removeImage: "Remover imagem",
    sending: "Enviando...",
    addComment: "Adicionar Comentário",
    history: "Histórico de Alterações",
    historyDesc: "Registro completo de todas as alterações no chamado",
    noChanges: "Nenhuma alteração registrada ainda",
    reasonLabel: "Motivo:",
    changedByLabel: "Por:",
    typeIncident: "Incidente",
    typeRequest: "Requisição",
    typeProblem: "Problema",
    typeChange: "Mudança",
    changeTypeCreated: "Chamado Criado",
    changeTypeStatusChange: "Mudança de Status",
    changeTypePriorityChange: "Mudança de Prioridade",
    changeTypeCategoryChange: "Mudança de Categoria",
    changeTypeTrackingStatusChange: "Mudança de Acompanhamento",
    changeTypeQueueChange: "Mudança de Fila",
    changeTypeAssignment: "Atribuição",
    changeTypeTransfer: "Transferência",
    changeTypeLink: "Vinculação",
    changeTypeUnlink: "Desvinculação",
    changeTypeReopen: "Reabertura",
    changeTypeSystemClose: "Fechado pelo Sistema",
    changeTypeCommentAdded: "Comentário Adicionado",
    changeTypeAttachmentAdded: "Anexo Adicionado",
    changeTypeNpsRated: "Avaliação (NPS)",
    changeTypeFieldUpdate: "Atualização de Campo",
    parentIdLabel: "Vínculo (Chamado Pai)",
    commentLabel: "Comentário",
    attachmentsLabel: "Anexos",
    npsScoreLabel: "NPS",
    trackingPaused: "Pausado",
    noLink: "Sem vínculo",
    attachmentCount: (n: number) => (n === 1 ? "1 anexo" : `${n} anexos`),
    manageTicket: "Gerenciar Chamado",
    manageDesc: "Alterar status, prioridade e atribuir responsável",
    status: "Status",
    priorityLabel: "Prioridade",
    trackingStatus: "Status de Acompanhamento",
    queue: "Fila de Atendimento",
    assigneeLabel: "Responsável",
    selectAssignee: "Selecione um responsável",
    removeAssignment: "Remover Atribuição",
    saveChanges: "Salvar Alterações",
    saving: "Salvando...",
    quickActions: "Ações Rápidas",
    quickActionsDesc: "Finalizar, fechar ou reabrir chamado rapidamente",
    closureReason: "Motivo do encerramento",
    closureReasonPlaceholder: "Explique por que o chamado está sendo finalizado...",
    closureReasonHint: "Esse texto aparece na comunicação e no histórico do chamado.",
    resolveTicket: "Finalizar Chamado (Resolver)",
    closeTicket: "Fechar Chamado",
    reopenTicket: "Reabrir Chamado",
    reopenDeadlineExpired: "O prazo para reabertura deste chamado expirou.",
    transferTicket: "Transferir Chamado",
    transferDesc: "Escolha como deseja transferir",
    transferOption: "Opção de Transferência",
    transferToTechnician: "Transferir para outro técnico",
    transferQueueOnly: "Transferir apenas a fila (mantém responsável)",
    newAssignee: "Novo Responsável",
    destinationQueue: "Fila de Destino",
    optionalQueue: "Fila de Destino (opcional)",
    optionalQueuePlaceholder: "Automática (fila preferencial do técnico)",
    optionalQueueHint: "Se não escolher, a fila será definida automaticamente pela fila preferencial do técnico de destino.",
    transferReason: "Motivo da Transferência",
    transferReasonPlaceholder: "Explique o motivo da transferência...",
    transferBtn: "Transferir Chamado",
    queueChangeHint: "Alterar a fila move o chamado para outro nível de atendimento",
    reopenTitle: "Reabrir Chamado",
    reopenDesc: "Reabrir chamado se o problema não foi resolvido adequadamente",
    reopenDialogDesc: (id: string | number) => `Informe o motivo da reabertura do chamado #${id}`,
    reopenReasonLabel: "Motivo da Reabertura",
    reopenReasonPlaceholder: "Explique por que o chamado precisa ser reaberto...",
    reopenDeadline: "Prazo para reabertura:",
    cancel: "Cancelar",
    confirm: "Confirmar",
    reassignTicket: "Reatribuir Chamado",
    assignTicket: "Atribuir Chamado",
    selectForTicket: "Selecione o responsável pelo chamado",
    ticketTitle: "Título do Chamado",
    currentAssignee: "Responsável Atual",
    assignTo: "Atribuir para",
    notAssigned: "Não atribuído",
    printAttached: "Print anexado",
    printAttachedDesc: "Imagem colada e adicionada ao comentário.",
    error: "Erro",
    loadError: "Não foi possível carregar os dados do chamado.",
    commentAdded: "Comentário adicionado",
    ticketUpdated: "Chamado atualizado",
    noChangesToSave: "Nenhuma alteração",
    noChangesToSaveDesc: "Não há alterações para salvar.",
    updateError: "Não foi possível atualizar o chamado.",
    transferSuccess: "Chamado transferido",
    assignSuccess: "Chamado atribuído",
    assignmentRemoved: "Atribuição removida",
    assignmentRemovedDesc: "O chamado não possui mais responsável.",
    reopenSuccess: "Chamado reaberto",
    resolveSuccess: "Chamado resolvido",
    closeSuccess: "Chamado fechado",
    unlinkSuccess: "Chamado desvinculado",
    slaExpired: "SLA Vencido",
    statusOpen: "Aberto",
    statusInProgress: "Em Atendimento",
    statusWaiting: "Aguardando Resposta",
    statusResolved: "Resolvido",
    statusClosed: "Fechado",
    priorityCritical: "Crítica",
    priorityHigh: "Alta",
    priorityMedium: "Média",
    priorityLow: "Baixa",
    queueN1: "N1 - Primeiro Nível",
    queueN2: "N2 - Segundo Nível",
    queueN3: "N3 - Especializado",
    trackingMonitoring: "Monitorando",
    trackingWaiting: "Aguardando",
    trackingResolved: "Resolvido",
    trackingEscalated: "Escalado",
    loadingTicketInfo: "Carregando informações do chamado...",
    categoryInfra: "Infraestrutura",
    categoryHardware: "Hardware",
    categorySoftware: "Software",
    categoryAccess: "Acesso e Permissões",
    categoryPerformance: "Performance",
    roleAdmin: "Admin",
    roleAnalyst: "Analista",
    roleAttendant: "Atendente",
    meShort: "Eu",
    noName: "Sem nome",
    noEmail: "Sem email",
    actions: "Ações",
    reasonRequired: "Motivo obrigatório",
    reasonRequiredDesc: "Informe o motivo do encerramento para finalizar o chamado.",
    selectTechnician: "Selecione o técnico",
    selectQueue: "Selecione a fila",
    noAssigneeTransfer: "Este chamado não possui responsável. Selecione um técnico para transferir.",
    noAssigneeQueue: "Este chamado está sem responsável. Para mudar a fila, primeiro atribua um técnico.",
    pleaseProvideReopen: "Por favor, informe o motivo da reabertura.",
  },
  serviceCatalog: {
    title: "Catálogo de Serviços",
    subtitle: "Escolha um serviço para abrir um chamado",
    subtitleAlt: "Conheça os serviços disponíveis e seus prazos de atendimento",
    searchPlaceholder: "Buscar serviços...",
    openTicket: "Abrir Chamado",
    noServices: "Nenhum serviço encontrado",
    noServicesDesc: "Tente ajustar os filtros ou a busca.",
    allCategories: "Todas as categorias",
    all: "Todos",
    addService: "Adicionar Serviço",
    loading: "Carregando...",
    noServicesFilter: "Nenhum serviço encontrado com os filtros selecionados.",
    category: "Categoria:",
    sla: "SLA:",
    estimatedTime: "Tempo Estimado:",
    requestService: "Solicitar Serviço",
    addServiceTitle: "Adicionar Serviço ao Catálogo",
    addServiceDesc: "Administradores podem adicionar novos serviços para a empresa.",
    name: "Nome *",
    namePlaceholder: "Ex: Solicitar Acesso ao Sistema X",
    description: "Descrição *",
    descriptionPlaceholder: "Explique o que este serviço cobre...",
    categoryLabel: "Categoria *",
    categoryPlaceholder: "Ex: Infraestrutura",
    type: "Tipo *",
    select: "Selecione",
    incident: "Incidente",
    request: "Requisição",
    problem: "Problema",
    change: "Mudança",
    slaOptional: "SLA (opcional)",
    slaPlaceholder: "Ex: 24h - 48h",
    estimatedTimeOptional: "Tempo Estimado (opcional)",
    estimatedTimePlaceholder: "Ex: 1-2 dias",
    company: "Empresa *",
    selectCompany: "Selecione a empresa",
    companyRequiredHint: "Para admin global (sem empresa), é obrigatório escolher.",
    cancel: "Cancelar",
    save: "Salvar",
    requiredFields: "Campos obrigatórios",
    requiredFieldsDesc: "Preencha Nome, Descrição, Categoria e Tipo.",
    companyRequired: "Empresa obrigatória",
    companyRequiredDesc: "Selecione a empresa para adicionar o serviço.",
    serviceAdded: "Serviço adicionado",
    serviceAddedDesc: "O item já aparece no Catálogo.",
    error: "Erro",
    errorLoad: "Não foi possível carregar o catálogo.",
    errorRemove: "Erro ao remover serviço.",
    errorAdd: "Erro ao adicionar serviço.",
    removeConfirm: "Deseja remover este serviço do catálogo?",
    removed: "Removido",
    removedDesc: "Serviço removido do catálogo.",
    deleteBtn: "Apagar",
    removeTitle: "Remover do catálogo",
    selectPlaceholder: "Selecione...",
    default1Name: "Suporte a Infraestrutura",
    default1Desc: "Atendimento para problemas de servidores, rede, e-mail e conectividade",
    default1Category: "Infraestrutura",
    default2Name: "Suporte a Hardware",
    default2Desc: "Reparo e manutenção de computadores, notebooks, impressoras e periféricos",
    default2Category: "Hardware",
    default3Name: "Suporte a Software",
    default3Desc: "Instalação, configuração e resolução de problemas em aplicativos",
    default3Category: "Software",
    default4Name: "Solicitação de Acesso",
    default4Desc: "Criação de usuários, permissões e acesso a sistemas",
    default4Category: "Acesso e Permissões",
    default5Name: "Análise de Performance",
    default5Desc: "Investigação de problemas de lentidão e otimização de sistemas",
    default5Category: "Performance",
    default6Name: "Mudanças em Infraestrutura",
    default6Desc: "Atualizações, migrações e alterações em servidores e rede",
    default6Category: "Infraestrutura",
  },
  reports: {
    title: "Relatórios",
    subtitle: "Gere relatórios de chamados por período",
    subtitleAlt: "Gere relatórios detalhados sobre o desempenho dos chamados",
    generateReport: "Gerar Relatório",
    generating: "Gerando...",
    selectDates: "Selecione as datas inicial e final",
    reportGenerated: "Relatório gerado",
    reportGeneratedDesc: "O relatório foi gerado com sucesso.",
    error: "Erro",
    errorGenerating: "Não foi possível gerar o relatório.",
    generateFirst: "Gere um relatório primeiro",
    exportPdf: "Exportar PDF",
    exportCsv: "Exportar CSV",
    exportExcel: "Exportar Excel",
    period: "Período",
    startDate: "Data inicial",
    endDate: "Data final",
    reportType: "Tipo de Relatório",
    summary: "Resumo",
    configureReport: "Configurar Relatório",
    configureDesc: "Selecione o tipo de relatório e o período desejado",
    summaryExecutive: "Resumo Executivo",
    detailed: "Detalhado",
    slaAnalysis: "Análise de SLA",
    byTechnician: "Por Técnico",
    byCategory: "Por Categoria",
    exportSuccess: "Exportado com sucesso",
    exportCsvDesc: "Arquivo CSV baixado",
    exportExcelDesc: "Arquivo Excel baixado",
    allowPopups: "Permita pop-ups para exportar PDF",
    openingPrint: "Abrindo impressão",
    openingPrintDesc: "Use a opção 'Salvar como PDF' na janela de impressão",
    reportMonthlyPdf: "Relatório Mensal (PDF)",
    performanceCsv: "Dados de Performance (CSV)",
    satisfactionExcel: "Satisfação do Usuário (Excel)",
    exportReports: "Exportar Relatórios",
    exportReportsDesc: "Gerar relatórios detalhados para análise",
    ticketsByCategory: "Chamados por Categoria",
    slaMetrics: "Métricas de SLA",
    slaCompliance: "SLA Cumprido",
    averageResolutionTime: "Tempo Médio de Resolução",
    averageResponseTime: "Tempo Médio de Resposta",
    firstResolution: "Primeira Resolução",
    reportTitle: "Relatório de Chamados",
    periodLabel: "Período",
    metric: "Métrica",
    value: "Valor",
    totalTickets: "Total de Chamados",
    backlog: "Backlog",
    backlogOverdue: "Backlog em Atraso",
    backlogSlaBreached: "Backlog Passou do SLA",
    backlogTransferred: "Backlog Transferido",
    totalTransferred: "Total Transferidos",
    multipleTransfers: "Múltiplas Transferências",
    open: "Abertos",
    resolved: "Resolvidos",
    closed: "Fechados",
    reopenRate: "Taxa de Reabertura",
    npsAverage: "NPS Médio",
    category: "Categoria",
    quantity: "Quantidade",
    ticketsByTechnician: "Chamados por Técnico",
    technician: "Técnico",
    noDataInPeriod: "Nenhum dado no período",
    slaComplianceShort: "Conformidade SLA",
    violations: "Violações",
    backlogByAge: "Backlog por Idade",
    age: "Idade",
    metOfTotal: (met: number, total: number) => `${met} de ${total} cumpridos`,
    overdueTickets: "Chamados em Atraso",
    daysOverdue: (n: number) => `${n} dias em atraso`,
    performanceByTechnician: "Performance por Técnico",
    ticketsCount: (n: number) => `${n} chamados`,
    averageTime: "Tempo Médio",
    categoryAnalysis: "Análise por Categoria",
    percentOfTotal: (p: number) => `${p}% do total`,
    noTechnicianFound: "Nenhum técnico encontrado no período",
    noCategoryFound: "Nenhuma categoria encontrada no período",
    periodSummary: "Resumo do Período",
    backlogSlaViolations: "Backlog - Violações de SLA",
    overdueOpen: "Em atraso (abertos)",
    passedSla: "Passaram do SLA (total)",
    violationsInPeriod: "Violações no período",
    transferredTicketsCard: "Chamados Transferidos",
    totalTransferredShort: "Total transferidos",
    backlogTransferredShort: "Backlog transferido",
    multipleTransfersShort: "Múltiplas transferências",
    transferredAnalysis: "Análise de Chamados Transferidos",
    transferredStatsDesc: "Estatísticas sobre chamados que foram transferidos entre técnicos",
    distribution: "Distribuição",
    transferredAndResolved: "Chamados transferidos e resolvidos",
    transferredStillOpen: "Chamados transferidos ainda abertos",
    multipleTransfersRate: "Taxa de múltiplas transferências",
    ofTotal: (p: number) => `${p}% do total`,
    ofBacklog: (p: number) => `${p}% do backlog`,
    transferredMoreThanOnce: "Chamados transferidos mais de uma vez",
    slaQuality: "Conformidade SLA",
    violationsInPeriodShort: (n: number) => `${n} violações no período`,
    slaByCategory: "SLA por Categoria",
    metOfTotalDetail: (met: number, withSla: number, total: number) => `${met} de ${withSla} cumpridos (${total} total)`,
    generatedAt: "Gerado em",
    inOverdue: "em atraso",
    slaBreachedShort: "passaram do SLA",
    transferredShort: "transferidos",
  },
  adminDashboard: {
    title: "Dashboard Admin",
    subtitle: "Gestão de chamados, empresas e usuários",
    subtitleAlt: "Visão geral da equipe técnica e performance do ITSM",
    tickets: "Chamados",
    companies: "Empresas",
    users: "Usuários",
    loading: "Carregando...",
    loadingData: "Carregando dados...",
    totalTickets: "Total Chamados",
    queueTab: "Fila de Atendimento",
    technicians: "Técnicos",
    settings: "Configurações",
    queueTitle: "Fila de Chamados",
    queueDesc: "Gerenciar atribuições e prioridades",
    averageTime: "Tempo Médio",
    satisfaction: "Satisfação",
    total: "Total",
    results: "Resultados",
    active: "Ativa",
    inactive: "Inativa",
    activePlural: "Ativas",
    inactivePlural: "Inativas",
    activeMale: "Ativos",
    inactiveMale: "Inativos",
    edit: "Editar",
    deactivate: "Desativar",
    remove: "Remover",
    filterByStatus: "Filtrar por status",
    filterByProfile: "Filtrar por perfil",
    filterByCompany: "Filtrar por empresa",
    all: "Todas",
    allProfiles: "Todos os Perfis",
    allStatuses: "Todos os Status",
    allCompanies: "Todas as Empresas",
    noCompany: "Sem Empresa",
    companyManagement: "Gerenciamento de Empresas",
    companyManagementDesc: "Cadastre e gerencie empresas usuárias do sistema",
    searchCompanyPlaceholder: "Buscar por nome, domínio ou telefone...",
    newCompany: "Nova Empresa",
    downloadTemplate: "Baixar modelo",
    importCsv: "Importar CSV",
    ticketsUnlimited: "Ilimitado",
    ticketsCount: (used: number, limit: number) => `Tickets: ${used}/${limit}`,
    peopleCount: (n: number) => (n === 1 ? "1 pessoa cadastrada" : `${n} pessoas cadastradas`),
    userManagement: "Gerenciamento de Usuários",
    userManagementDesc: "Visualize, filtre e gerencie todos os usuários do sistema",
    importUsers: "Importar Usuários",
    addUser: "Adicionar Usuário",
    searchUserPlaceholder: "Buscar por nome ou email...",
    company: "Empresa",
    domain: "Domínio",
    resetPassword: "Resetar Senha",
    delete: "Excluir",
    manageCategories: "Gerenciar Categorias",
    manageCategoriesDesc: "Adicionar ou editar categorias de chamados",
    ticketsCountLabel: (n: number) => (n === 1 ? "1 chamado" : `${n} chamados`),
    categoryTicketsCount: (n: number) => (n === 1 ? "(1 chamado)" : `(${n} chamados)`),
    noCategoriesFound: "Nenhuma categoria encontrada. Adicione uma nova categoria para começar.",
    addNewCategory: "Adicionar Nova Categoria",
    addCategoryDialogTitle: "Adicionar Nova Categoria",
    addCategoryDialogDesc: "Crie uma nova categoria de chamados. A categoria ficará disponível para uso ao criar novos tickets.",
    categoryNameLabel: "Nome da Categoria",
    categoryNamePlaceholder: "Ex: Segurança TI",
    categoryNameHint: "Digite o nome da categoria que deseja adicionar",
    add: "Adicionar",
    editCategoryDialogTitle: "Editar Categoria",
    editCategoryDialogDesc: (name: string) => `Renomeie a categoria "${name}". Todos os chamados com esta categoria serão atualizados.`,
    newCategoryNameLabel: "Novo Nome da Categoria",
    newCategoryNamePlaceholder: "Digite o novo nome",
    removeCategoryDialogTitle: "Remover Categoria",
    removeCategory: "Remover Categoria",
    exportNps: "Exportar Votações NPS",
    exportNpsDesc: "Exporte todas as avaliações NPS com comentários para treinamento e controle de qualidade",
    training: "Treinamento",
    qualityControl: "Controle de Qualidade",
    xlsxRecommended: "XLSX recomendado",
    exportIncludes: "A exportação inclui: nota NPS (0-10), comentários, dados do chamado, cliente, técnico responsável, empresa e datas relevantes.",
    format: "Formato",
    selectFormat: "Selecione o formato",
    xlsxRecommendedOption: "XLSX (recomendado)",
    exporting: "Exportando...",
    exportXlsx: "Exportar XLSX",
    exportXls: "Exportar XLS",
    exportCsv: "Exportar CSV",
    xlsxKeepsFields: "O XLSX mantém cada campo em sua própria célula.",
    newCompanyDialogTitle: "Nova Empresa",
    editCompanyDialogTitle: "Editar Empresa",
    editUserDialogTitle: "Editar Usuário",
    addUserDialogTitle: "Adicionar Usuário",
    cancel: "Cancelar",
    saveChanges: "Salvar Alterações",
    activate: "Ativar",
    noUsersFound: "Nenhum usuário encontrado com os filtros aplicados",
    noCompaniesFound: "Nenhuma empresa encontrada",
    createFirstCompany: "Criar Primeira Empresa",
    importCompanies: "Importar Empresas",
    newCompanyDialogDesc: "Cadastre uma nova empresa usuária no sistema",
    editCompanyDialogDesc: "Altere as informações da empresa conforme necessário",
    editUserDialogDesc: "Altere as informações do usuário conforme necessário.",
    addUserDialogDesc: "Crie um novo analista e associe-o à empresa correta.",
    importUsersDialogDesc: "Baixe o modelo, preencha e envie a planilha. Campos do cadastro normal: nome, email, telefone, dominio_empresa, setor, funcao.",
    importCompaniesDialogDesc: "Baixe o modelo, preencha e envie o CSV. Campos obrigatórios: name e domain. Os demais seguem o cadastro normal.",
    noFileChosen: "Nenhum arquivo escolhido",
    importing: "Importando...",
    saving: "Salvando...",
    sendCsv: "Enviar CSV",
    internalUser: "Usuário interno",
    removeCategoryDialogDesc: (name: string) => `Tem certeza que deseja remover a categoria "${name}"?`,
    selectTargetCategoryPlaceholder: "Selecione a categoria de destino",
    roleAdminInternal: "Admin Interno",
    roleAdministrator: "Administrador",
    roleAnalyst: "Analista",
    roleUser: "Usuário",
    downloadTemplateReady: "Baixar modelo pronto",
    chooseFile: "Escolher arquivo",
    spreadsheet: "Planilha",
    import: "Importar",
    nameLabel: "Nome",
    emailLabel: "E-mail",
    fullNamePlaceholder: "Nome completo",
    filterByQueue: "Filtrar por fila",
    filterByTechnician: "Filtrar por técnico",
    filterByLevel: "Nível de Atendimento",
    allQueues: "Todas as Filas",
    allTechnicians: "Todos os Técnicos",
    allLevels: "Todos os Níveis",
    queueInfra: "Infraestrutura",
    queueHardware: "Hardware",
    queueSoftware: "Software",
    queueSecurity: "Segurança TI",
    levelN1: "N1 - Primeiro Nível",
    levelN2: "N2 - Segundo Nível",
    levelN3: "N3 - Especializado",
    slaExpiredBadge: "SLA VENCIDO",
    transferCount: (n: number) => `${n} transf.`,
    categoryLabel: "Categoria",
    requesterLabel: "Solicitante",
    slaLabel: "SLA",
    assigneeLabel: "Responsável",
    notAssigned: "Não atribuído",
    assign: "Atribuir",
    reassign: "Reatribuir",
    urgentAction: "Ação urgente necessária",
    clickToOpen: "Clique para abrir o chamado",
    noTicketsQueue: "Nenhum chamado encontrado. Os botões de atribuição aparecerão aqui quando houver chamados.",
    noTicketsFiltered: "Nenhum chamado encontrado com os filtros aplicados. Ajuste os filtros acima.",
    techniciansPerformance: "Performance dos Técnicos",
    techniciansPerformanceDesc: "Distribuição de carga de trabalho e produtividade",
    resolved: "resolvidos",
    resolutionRate: "Taxa de resolução",
    ticketTitle: "Título do Chamado",
    currentAssignee: "Responsável Atual",
    assignTo: "Atribuir para",
    loadingUsers: "Carregando usuários...",
    selectAssignee: "Selecione um responsável",
    me: "(Eu)",
    confirm: "Confirmar",
    assignTicketTitle: "Atribuir Chamado",
    reassignTicketTitle: "Reatribuir Chamado",
    assignTicketDialogDesc: (id: string | number) => `Selecione o responsável pelo chamado ${id}`,
    // Configurações (Settings)
    brandingTitle: "Identidade Visual da Empresa",
    brandingDesc: (company: string) => `Personalize logo e cores do portal de ${company}.`,
    brandingYourCompany: "sua empresa",
    loadingBranding: "Carregando branding...",
    lastSavedConfig: "Última configuração salva",
    logoSaved: "Logo salvo",
    noLogoSaved: "Sem logo salvo.",
    primaryColor: "Primária",
    secondaryColor: "Secundária",
    companyLogo: "Logo da Empresa",
    uploadLogoHint: "Envie um arquivo PNG/JPG (máximo recomendado 1MB).",
    primaryColorLabel: "Cor Primária",
    secondaryColorLabel: "Cor Secundária",
    preview: "Pré-visualização",
    saveBranding: "Salvar Identidade Visual",
    brandingUpdated: "Branding atualizado",
    brandingUpdatedDesc: "As cores e o logo foram salvos com sucesso.",
    logoUploaded: "Logo enviado",
    logoUploadedDesc: "Logo atualizado com sucesso.",
    brandingSaveError: "Não foi possível salvar o branding.",
    logoUploadError: "Não foi possível enviar o logo.",
    errorTitle: "Erro",
    categoryAdded: "Categoria adicionada",
    categoryUpdated: "Categoria atualizada",
    categoryRemoved: "Categoria removida",
    /** Mapeamento opcional: nome da categoria no BD -> nome exibido no idioma atual. Corrige "Performace" e traduz nomes conhecidos. */
    categoryDisplayName: (name: string) => {
      const map: Record<string, string> = {
        "Performace": "Performance",
      };
      return map[name] ?? name;
    },
  },
} as const;

export type Translations = typeof pt;
